'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserDetails$package$UserLastName$() {
  this.aGm = null;
  this.aGn = false;
}
export { $c_Lapp_data_UserDetails$package$UserLastName$ as $c_Lapp_data_UserDetails$package$UserLastName$ };
$p = $c_Lapp_data_UserDetails$package$UserLastName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_UserDetails$package$UserLastName$;
/** @constructor */
function $h_Lapp_data_UserDetails$package$UserLastName$() {
}
export { $h_Lapp_data_UserDetails$package$UserLastName$ as $h_Lapp_data_UserDetails$package$UserLastName$ };
$h_Lapp_data_UserDetails$package$UserLastName$.prototype = $p;
$p.aA = (function() {
  if ((!this.aGn)) {
    this.aGm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aGn = true;
  }
  return this.aGm;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_UserDetails$package$UserLastName$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserDetails$package$UserLastName$, "app.data.UserDetails$package$UserLastName$", ({
  Fe: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_UserDetails$package$UserLastName$ as $d_Lapp_data_UserDetails$package$UserLastName$ };
var $n_Lapp_data_UserDetails$package$UserLastName$;
function $m_Lapp_data_UserDetails$package$UserLastName$() {
  if ((!$n_Lapp_data_UserDetails$package$UserLastName$)) {
    $n_Lapp_data_UserDetails$package$UserLastName$ = new $c_Lapp_data_UserDetails$package$UserLastName$();
  }
  return $n_Lapp_data_UserDetails$package$UserLastName$;
}
export { $m_Lapp_data_UserDetails$package$UserLastName$ as $m_Lapp_data_UserDetails$package$UserLastName$ };
//# sourceMappingURL=app.data.-User-Details$package$-User-Last-Name$.js.map
